import "./applet_quota_banner.scss"

interface Props {
  onClick: () => {}
}

const AppletQuotaBanner = ({ onClick }: Props) => (
  <a
    onClick={onClick}
    data-turbolinks="false"
    styleName="applet-quota-banner"
    data-track-ifttt-next-event="click"
    data-track-data={JSON.stringify({
      object_type: "applet_quota_banner",
      location_type: "diy_composer",
    })}
  >
    You have reached your Applet limit. <span styleName="cta">You need to upgrade to enable this Applet.</span>
  </a>
)

export default AppletQuotaBanner
